import { Typography } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { useFormikContext } from 'formik';
import CardWithIcon from 'components/new-ui/base/card/CardWithIcon';
import FormTextArea from 'components/new-ui/composed/formTextArea/FormTextArea';
import { EMPTY } from 'views/customers/customer/utils';
import { usePartyContext } from '../../../../PartyProvider';
import { FormFields, FormValues } from '../../types';

type Props = {
    isEditing: boolean;
};

const SpecialInstructions = ({ isEditing }: Props) => {
    const { canUpdate, customer } = usePartyContext();
    const formik = useFormikContext<FormValues>();

    const content = isEditing ? (
        <FormTextArea
            rows={4}
            disabled={!canUpdate}
            style={{ width: '100%' }}
            placeholder="Enter special instructions"
            value={formik.values.specialInstructions ?? undefined}
            onChange={(e) => formik.setFieldValue(FormFields.SpecialInstructions.SPECIAL_INSTRUCTIONS, e.target.value)}
            fieldProps={formik.getFieldProps(FormFields.SpecialInstructions.SPECIAL_INSTRUCTIONS)}
            fieldHelper={formik.getFieldHelpers(FormFields.SpecialInstructions.SPECIAL_INSTRUCTIONS)}
            fieldMeta={formik.getFieldMeta(FormFields.SpecialInstructions.SPECIAL_INSTRUCTIONS)}
        />
    ) : (
        <Typography.Paragraph style={{ whiteSpace: 'pre-line' }}>
            {customer.specialInstructions ?? EMPTY}
        </Typography.Paragraph>
    );

    return (
        <CardWithIcon
            bordered={false}
            title="Special Instructions"
            gap="large"
            iconProps={{
                icon: <EditOutlined />,
                status: 'note',
            }}
            children={<div style={{ marginTop: 24 }}>{content}</div>}
        />
    );
};

export default SpecialInstructions;
